<template>
  <div v-if="selectedModel" class="model_card mb-4 text-center cursor_pointer  p-3"
    :style="[{ background: isGradient ? transparentColor : '#fff' }]" :class="[{ custom_box_shadow: !isGradient }]">
    <div class="d-flex align-items-center justify-content-center">
      <div>
        <img :src="selectedModel.vehicleImage" alt="" class="img-fluid" v-if="selectedModel.vehicleImage" />
        <img src="../../../../../../images/no-image.png" alt="" class="img-fluid" v-else />
      </div>
      <div class="p-3" :style="[{ color: isGradient ? textColor : '#000' }]">
        <div class="mb-3">
          <h2 class="m-0">{{ selectedModel.vehiclesCount }}</h2>
          <small>in stock</small>
        </div>
        <p>{{ selectedModel.displayName }}</p>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      selectedModel: {},
      primaryColor: window.primaryColor,
      isChecked: null,
      transparentColor: '',
      textColor: '#000',
    }
  },

  mounted() {

    if (this.botResponse?.component?.value) {
      this.selectedModel = this.botResponse?.component?.value;
    }
    if (this.chatThemeSettings?.primeColor) {
      this.primaryColor = this.chatThemeSettings.primeColor;
    }
    if (this.isGradient) {
      this.transparentColor = 'rgba(0, 0, 0, 0.1)';
      this.textColor = '#fff';
      this.primaryColor = '#fff'
    }

  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
  },
}
</script>
<style lang="less" scoped>
.model_card {
  border-radius: 10px;
  max-width: 500px;

  img {
    max-height: 150px;
  }

  h2 {
    font-size: 50px;
    opacity: 0.5;
  }

  p {
    font-size: 20px;
  }

}
</style>
